export default {
    txt_welcome: 'Benvenuto',
    txt_dataover: 'Panoramica dei dati',
    txt_chance: 'Opportunità vendita',
    txt_device: 'Dispositivo',
    txt_chinese: 'Cinese',
    txt_english: 'Inglese',
    txt_malay: 'Malese',
    txt_german: 'Deutsch',
    txt_french: 'French',
    txt_italian: 'Italiano',
    txt_spanish: 'Español',
    txt_reports: 'Cronologia',
    txt_setting: 'Impostazioni di sistema',
    txt_dymanager: 'Gestione degli impiegati',
    txt_account: 'Account',
    txt_userstatus: "Identità dell'utente",
    txt_name: 'Nome e cognome',
    txt_contactway: 'Informazioni di contatto',
    txt_accountsafe: 'Sicurezza account',
    txt_basicinfo: 'Informazioni di base',
    txt_updatepassword: 'Cambia password',
    txt_storeinfomation: 'Informazi oni sul negozio',
    txt_storename: 'Nome negozio',
    txt_storephone: 'Telefono del negozio',
    txt_storeaddress: 'Telefono del negozio',
    txt_AppInfomation: 'Informazioni app',
    txt_currentversion: 'Numero di versione',
    txt_software: 'Aggiornamento del software',
    txt_loginout: 'Esci dal login',
    txt_updatelanguage: 'Lingua',
    txt_updateto: 'Aggiorna a',
    txt_zwgx: 'Nessun aggiornamento',
    txt_dz: 'Responsabile del negozio',
    txt_sh: 'Commerciante',
    txt_dy: 'Gestione degli impiegati',
    txt_bdsj: 'Associa il telefono cellulare',
    txt_shxx: 'Informazioni sul commerciante',
    txt_shname: 'Nome del commerciante',
    txt_ssmd: 'Negozio',
    txt_bdsb: 'Il dispositivo è associato',
    txt_mendian: 'Negozio',


    //数据总览模块
    txt_sTime: 'Periodo di rilevamento',
    txt_car_check: 'Tasso di controllo del veicolo',
    txt_findchance: 'Scopri le opportunità',
    txt_trackchace: 'Tracciamento delle opportunità',
    txt_transform: 'Tasso di conversione',
    txt_TotalData: 'Panoramica dei dati',
    txt_xxsj: 'Dati dettagliati',
    txt_zhsj: 'Numero di conversione',
    txt_TireWear: 'Usura',
    txt_DataHopper: 'Canalizzazione dati',
    txt_jdcc: 'Numero di veicoli che entrano nel negozio',
    txt_CheckCar: 'Scansione',
    txt_ChanceNum: 'Opportunità quantità vendita',
    txt_TrackNum: 'Tracciato',
    txt_TranseformNum: 'Numero di conversione',
    txt_UnTrack: 'Non tracciato',
    txt_l: 'Veicoli',
    txt_Time: 'Tempo di conversione',
    txt_Device: 'Dispositivo',
    txt_car_plate: 'NUMERO DI TARGA',
    txt_Wear: 'Usura',
    txt_Pwear: 'Usura parziale',
    txt_NoData: 'Sin datos',
    txt_GoodState: 'Buono stato',
    txt_Border: 'Stato limite',
    txt_replace: 'Sostituisci immediatamente',
    txt_Total_Check: 'Totale',
    txt_pmqk: 'Usura irregolare',
    txt_LightWear: 'Stato limite',
    txt_GraveWear: 'Stato grave',
    txt_hwtj: 'Numero rotazioni',
    txt_wxhw: 'Rotazione non necessaria',
    txt_xyhw: 'Rotazione necessaria',
    txt_jcxq: 'Dati dettagliati',
    txt_zhxq: 'Dettagli di conversione',
    txt_cc: 'Veicoli',
    txt_bfb: '%',
    txt_ltxs: 'Vendite di pneumatici',
    txt_sldw: 'Sostituzione pneumatico',
    txt_ddlph: 'Saldo',
    txt_dphhh: 'Saldo',
    txt_qt: 'Altro',
    txt_zhqs: 'Tendenza di conversione',
    txt_ltxl: 'Vendite di pneumatici',
    txt_ltfw: 'Servizio pneumatici',
    txt_ckxq: 'Dati dettagliati',
    txt_jt: 'Oggi',
    txt_zt: 'Ieri',
    txt_bz: 'Questa settimana',
    txt_by: 'Questo mese',
    txt_sy: 'Mese scorso',
    txt_jn: "Quest'anno",
    txt_zhcl: 'Converti veicolo (q.tà)',
    txt_zhl: 'Tasso di conversione',
    txt_abjx: 'Distribuzione del numero di pneumatici nello stato limite',
    txt_aljg: 'Distribuzione del numero di pneumatici in sostituzione immediata',
    txt_qwpm: 'Distribuzione del numero di pneumatici sotto la leggera usura parziale',
    txt_ayzp: 'Distribuzione del numero di pneumatici sotto la grave usura parziale',
    txt_lingt: '0 Pneumatici',
    txt_yt: '1 Pneumatico',
    txt_et: '2 Pneumatici',
    txt_st: '3 Pneumatici',
    txt_ft: '4 Pneumatici',

    //机会
    txt_xsjh: 'Opportunità di vendita',
    txt_gzz: 'Tracciamento in corso.',
    txt_clwb: 'Elaborazione completa',
    txt_ckbg: 'Verifica rapporto',
    txt_yxs: 'Tutti i dati visualizzati',
    txt_zhuiz: 'Tracciamento',
    txt_tix: 'Promemoria di tracciamento',
    txt_chuli: 'Procedimento',
    txt_yzh: 'Convertito',
    txt_wzh: 'Non convertito',
    txt_gzsmts: '{0} le gomme hanno dei problemi，{1} andranno in riparazione',
    txt_czbty: "Il proprietario non è d'accordo",
    txt_yyx: 'Scopo',
    txt_ltyg: '1 Pneumatico',
    txt_ltkg: '2 Pneumatici',
    txt_ltsang: '3 Pneumatici',
    txt_ltsig: '4 Pneumatici',
    txt_jhcl: 'Procedimento',
    txt_jhztai: 'Stato',
    txt_crquy: 'Area di responsabilità',
    txt_chuliry: 'Processore',
    txt_chulijg: 'Result',
    txt_zhuanhuanr: 'Contenuto di conversione',
    txt_zhuanhuaje: 'Importo della conversione',
    txt_zhuanhuasj: 'Tempo di conversione',
    txt_zhuanhuayx: 'Tempo stimato',
    txt_xuanzesj: 'Seleziona durata',
    txt_tsdatawk: 'I dati non possono essere salvati se lo stato delle richieste di vendita è vuoto',
    txt_qtxzhsj: 'Per favore compila il tempo di conversione stimato',
    txt_qtxzhnr: 'Per favore compila il contenuto di conversione',
    txt_sbts: 'Salvataggio dati non riuscito, verifica la rete wireless',


    //设备
    txt_sbgl: 'Gestione dispositivi ',
    txt_tj: 'Aggiungi',
    txt_gdssb: 'Totale  dispositivi',
    txt_sbbh: 'Numero del dispositivo',
    txt_gjbb: 'Versione del firmware',
    txt_tjsj: 'Tempo aggiunto',
    txt_zdgx: 'Auto aggiornamento',
    txt_gxgj: 'Aggiornamento del software',
    txt_jieb: 'Dissocia',
    txt_sbtsxx: 'Il dispositivo è da aggiornare, clicca per procedere',
    txt_wjh: 'Disattivato',
    txt_lix: 'Offline',
    txt_zaix: 'Online',
    txt_guz: 'Guasto',
    txt_yijieb: 'Dissociato',
    txt_yihuis: 'Riciclato',
    txt_gxsbgj: 'Aggiorna dispositivo',
    txt_gxsbgjts: 'Vuoi aggiornare il dispositivo?',
    txt_socketdk: 'La comunicazione con il server non è stata stabilita, per favore riprova',
    txt_cscgts: 'Richiesta di aggiornamento del firmware inviata con successo',
    txt_jbsb: 'Scollega dispositivo',
    txt_jbsbts: 'Sei sicuro di voler dissocciare il dispositivo',
    txt_tscg: 'Riuscito ',
    txt_zdgxgj: 'Auto actualización',
    txt_gxgjts: 'Sei sicuro di voler {0} la funzione di aggiornamento automatico del firmware?',
    txt_beiz: 'Nota',
    txt_qtxbz: 'Per favore compila i commenti',
    txt_bdsbts: 'Questa APP è utilizzata solo per dispositivo rilevamento battistrada, verifica che il dispositivo sia corretto',
    txt_qdksb: 'Per favore accendi il dispositivo',
    txt_dksbts1: "L'associazione comincierà quando il dispositivo sarà acceso",
    txt_dksbts2: 'Se il dispositivo è stato associato ad altri negozi, clicca dissocia nel menù Configurazione per svincolarlo. Una volta dissociato, la procedura di associazione comincerà automaticamente',
    txt_yjdksblw: 'Il dispositivo è acceso e connesso alla rete',
    txt_xyb: 'Passo successivo',
    txt_qsclj: 'Sacn il codice QR',
    txt_qscts1: 'Per favore utilizza il dispositivo per scansionare il QR code, se la scansione va a buon fine, il dispositivo suona',
    txt_qscts2: 'Scansionato con successo',
    txt_sbtssmcg: 'Scansionato con successo',
    txt_ddsblw: 'Cerca connessione',
    txt_zznlbd: 'Il dispositivo è associato',
    txt_qszdd: 'Attendere prego',
    txt_bdcg: 'Associazione del dispositivo effettuata con successo',
    txt_tjcg: 'Aggiunto correttamente',
    txt_tjcgts: 'Congratulazioni, dispositivo aggiunto con successo. Nota il dispositivo per identificarlo',
    txt_fhsblb: "Torna all'elenco dei dispositivi",
    txt_jxtjsb: 'Continua ad aggiungere dispositivi',
    txt_bzmc: 'Nota dispositivo',


    //检测记录
    txt_sx: 'Seleziona',
    txt_khsj: 'Telefono cellulare del cliente',
    txt_cphm: 'NUMERO DI TARGA',
    txt_cphm1: 'NUMERO DI TARGA',
    txt_clxh: 'Modello veicolo',
    txt_xgbz: 'Modifica nota',
    txt_gtfjl: 'Totale',
    txt_jcsj: 'Data e ora scansione',
    txt_jcsj1: 'Data e ora scansione',
    txt_xzkssj: 'Ora inizio',
    txt_xzjssj: 'Ora fine',
    txt_jcjg: 'Risultato del rilevamento',
    txt_msqk: 'Usura del motivo',
    txt_jygh: 'Sostituisci immediatamente',
    txt_zysh: 'Stato limite',
    txt_zcsy: 'Buono stato',
    txt_zc: 'Buono stato',
    txt_cz: 'Ripristina',
    txt_qd: 'Conferma',
    txt_jcjgd: "Risultato dell'ispezione",
    txt_msqkd: 'Usura del motivo',
    txt_sldwd: 'Allineamento  ruote',
    txt_jyghd: 'Ostituisci immediatamente',
    txt_zcsyd: 'Buono stato',
    txt_xdwd: "L'allineamento è necessario",
    txt_xzyd: 'Fai attenzione',
    txt_zcd: 'Normale',
    txt_bgxq: 'Dati dettagliati',
    txt_ljdy: 'Connessione stampa',
    txt_fwmd: 'Negozio di servizi',
    txt_mddz: 'Indirizzo del negozio',
    txt_jcsb: 'Data e Ora scansione',
    txt_ddmd: "Scopo dell'arrivo",
    txt_lic: 'Chilometraggio',
    txt_chex: 'MODELLO VEICOLO',
    txt_jcjyi: 'Consigli per il rilevamento',
    txt_ysbs: 'Descrizione colore',
    txt_ztms: 'Usura generale',
    txt_hwms: 'Usura irregolare',
    txt_dqscjltx: 'Promemoria dello spazio di frenata attuale',
    txt_bgxqts: ' Nota',
    txt_wxsmgz: 'Wechat',
    txt_hwmsjh: 'Usura uniforme del motivo',
    txt_zqlun: 'Anteriore sinistra',
    txt_zhlun: 'Posteriore sinistra',
    txt_yqlun: 'Anteriore destra',
    txt_yhlun: 'Posteriore destra',
    txt_pingjunzhi: 'Valore medio:',
    txt_guige: 'Dimensioni',
    txt_gongli: 'KM',
    txt_ltwjc: 'Non ispezionato',
    txt_wheelalignment: 'Need to do dynamic balance and wheel alignment',
    txt_pinpai: 'Marca',
    txt_ltws: 'Difetto del pneumatico',
    txt_sewmts: 'Scansiona il codice QR per controllare il report',
    txt_print: 'Stampa',





    //店员管理
    txt_xz: 'Aggiungi',
    txt_qy: 'Attivo',
    txt_qyz: 'lavorazione',
    txt_ty: 'Disattiva',
    txt_yhzh: 'Account utente',
    txt_lxfs: 'Informazioni di contatto ',
    txt_cjsj: 'Tempo di creazione',
    txt_bjxx: 'Modifica',
    txt_xgmm: 'Cambia password',
    txt_bgzt: 'Cambia stato',
    txt_qdytjm: "Assicurati di disabilitare l'account?",
    txt_tjdy: 'Aggiungi',
    txt_bjdyxx: 'Modifica',
    txt_zhxx: 'Informazioni account',
    txt_ygxm: 'Nome del dipendente',
    txt_qtxygxm: 'Per favore inserisci il nome del dipendente',
    txt_lxdh: 'Informazioni contatto',
    txt_qtxyglxdh: 'Telefono',
    txt_dxyzm: 'Código de verificación de mensaje',
    txt_qtxdxyzm: 'Codice verifica SMS',
    txt_fsdx: 'Invia SMS',
    txt_tjzh: 'Aggiungi account ',
    txt_baocun: 'salva',
    txt_gtgygzh: 'Totale',



    //登录
    txt_qdytcdlm: 'Pronto per uscire',
    txt_qx: 'Annulla',
    txt_dl: 'Logout',
    txt_qsrzh: "Inserire l'id dell'account",
    txt_qsrmm: 'Inserisci la password',
    txt_zcshzh: 'Registro dei commercianti',
    txt_shzhwjmm: 'Password dimenticata',
    txt_yzdqmm: 'Verifica la password corrente',
    txt_szxmm: 'Imposta una nuova password',
    txt_xgcg: 'Modifica eseguita con successo',
    txt_qtxjmm: 'Per favore inserisci la vecchia password',
    txt_yzzcsj: 'Verifica numero cellulare',
    txt_qtxxmm: 'Inserisci nuova password',
    txt_qzctxxmm: 'Ripeti nuova password ',
    txt_lcmmsrbyz: 'Le due password non coincidono',
    txt_gxnxgcg: 'Password modificata con successo',
    txt_qljndxmm: 'Ricorda la tua nuova password',
    txt_fhgrzx: 'Ritorno al centro personale',
    txt_fsyzm: 'Invia il codice di verifica',
    txt_qtxzcsjh: 'Per favore inserisci il numero di cellulare',
    txt_qtxtxyzm: 'Per favore inserisci il codice di verifica grafico',
    txt_qsryzm: 'Per favore inserisci il codice di verifica',
    txt_qszhhmm: 'Per favore inserisci una nuova password di 6-18 cifre e lettere',
    txt_qzcsrmm: 'Per favore inserisci di nuovo la password',
    txt_lcmmbyz: 'Le due password non coincidono',
    txt_hdsy: 'Torna alla pagina principale',
    txt_zcshh: 'Registro dei commercianti',
    txt_fhdl: 'Torna alla pagina di accesso',
    txt_wlqqsb: 'Internet non funziona, riprova',
    txt_wczc: 'Registrazione completa',
    txt_wsts: ' Terminare altre informazioni prima di iniziare a usare App. ',
    txt_qtxshmc: 'Per piacere, inserisci il nome del commerciante',
    txt_shmc: 'Nome del commerciante',
    txt_rgszjd: 'Come numero di telefono aziendale, fax, ecc.',
    txt_qtlxfs: 'Altre informazioni di contatto',
    txt_kssy: 'Inizia a usare',
    txt_Pwear1: 'Usura parziale',
    txt_open: 'Apri',
    txt_close: 'Chiudi',
    txt_srczhdmm: 'Inserisci la nuova password',
    txt_kcfs: '{0} s',
    txt_xiugai: 'Modifica',
    txt_zzjzsj: 'Caricamento',
    txt_bjshxx: 'Modifica',
    txt_chongxinhq: 'Rispedisci',
    txt_gaibangsj: 'Modifica cellulare',
    txt_yanzhengjsj: 'Verifica il vecchio cellulare',
    txt_bangdingxsj: 'Collega al nuovo cellulare',
    txt_yhqsyxsjdl: 'Per favore, accedi al nuovo cellulare',



    //登录新
    txt_xzshenfen: 'Seleziona il tuo ruolo',
    txt_dlrolewz: 'Accedi',
    txt_qsrsjh: 'Inserisci il numero di telefono',
    txt_zhuce: 'Registrazione',
    txt_wanjimima: 'Password dimenticata',
    txt_wanshandzxx: 'Completa le informazioni',
    txt_qsrxm: 'Scrivi il tuo nome',
    txt_qsrmdm: 'Inserisci il nome del negozio',
    txt_qsrmdgddh: 'Inserisci il numero di telefono',
    txt_qsrmddz: "Inserisci l'indirizzo del negozio",
    txt_qsrgsdz: "Inserisci l'indirizzo dell'azienda",
    txt_qsrxxdz: "Inserisci l'indirizzo completo",
    txt_tijiaocg: 'Inviato con successo',
    txt_qsvbsylwmm: 'Password non inferiore a 6 caratteri',
    txt_zhucerole: "Registrazione dell'account {0}",
    txt_qsrshh: 'Por favor ingrese la cuenta de comerciante',
    txt_qsrdzh: "Inserisci l'account dell'amministratore",
    txt_wsshhzl: 'Completa le informazioni del commerciante',
    txt_wsdyhzl: 'Completa le informazioni dello staff',
    txt_qsrshm: 'Inserisci il nome del commerciante (Nome aziendale)',
    txt_qsrshz: 'Inserisci il proprietario ',
    txt_qsrzrqy: "Inserisci l'area di lavoro",
    txt_shanghudizhi: 'Indirizzo del commerciante',
    txt_yhycz: "Utente esistente",
    txt_qsrzqdzh: "Inserisci l'account corretto dell'amministratore",
    txt_qsrzqshh: "Inserisci l'account corretto del commerciante",
    txt_xzmdcx: 'Seleziona il negozio da consultare',



    //门店
    txt_mendianId: 'ID negozio',
    txt_mendianmc: 'Nome negozio',
    txt_mendiandz: 'Indirizzo del negozio',
    txt_mendiandh: 'Telefono del negozio',
    txt_caozuo: 'Funzionamento',
    txt_mendiangl: 'Gestione del negozio',
    txt_gjmendian: 'Totale',
    txt_zhengchangyy: 'Aperto',
    txt_tingye: 'Chiuso',
    txt_gengdxx: 'Più',
    txt_dianygl: 'Gestione degli impiegati',
    txt_biangzt: 'Cambia stato',
    txt_qdygbzhuangtai: 'Assicurati di disabilitare il negozio?',
    txt_bjmendian: 'Modifica',
    txt_xinzenmd: 'Aggiungi negozio',
    txt_qtxmdmc: 'Inserisci il nome del negozio. ',
    txt_qxzmddz: "Seleziona l'indirizzo del negozio",
    txt_qtxxdz: "Compila l'indirizzo del negozio",
    txt_xiangxidz: 'Indirizzo dettagliato',
    txt_qtxmddh: 'Per favore compila il telefono del negozio',
    txt_dzxx: 'Informazioni amministratore',
    txt_chaungjianmendian: 'Crea negozio',
    txt_mendianxxxx: 'Informazioni dettagliate',
    txt_bianji: 'Modifica',
    txt_mendianzt: 'Stato del negozio',

    //商户数据总览
    txt_mendianshuju: 'Dati negozio',
    txt_chakangdxxbb: 'Controlla più report',
    txt_jczcs: 'Totale ispezioni',
    txt_mdpjjc: 'Media ispezioni',
    txt_jdzcl: 'Flusso totale del veicolo ',
    txt_jcl: 'Flusso totale di veicoli ',
    txt_msqkjgtj: '磨损情况结果统计（轮胎条数）',
    txt_xyghltjgfb: '需更换轮胎的结果分布',
    txt_xzzyltjgfb: '需注意轮胎的结果分布',
    txt_sldwjgtj: '四轮定位结果统计（轮胎条数）',
    txt_xjxsldwfb: '需进行四轮定位轮胎的结果分布',
    txt_xzzyjxsldwfb: '需注意准备进行四轮定位轮胎的结果分布',
    txt_jrzl: 'Panoramica',
    txt_xiangqbb: 'Dettagli',
    txt_xuanzerqckxxsj: 'Seleziona data',
    txt_qxzsjd: 'Periodo di rilevamento',
    txt_sjdts: 'Puoi selezionare solo un periodo inferiore a 30 giorni',
    txt_zonglan: 'Panoramica',
    txt_qushi: 'Tendenza',
    txt_shuliangtj: 'Statistiche quantitative ',
    txt_syjcjgz: '所有检测结果中，各种磨损情况的轮胎条数及占比',
    txt_mslttsfb: '磨损轮胎条数分布情况',
    txt_msbgslzb: '(不同条数轮胎磨损的报告数量、以及在总检测数中的占比）',
    txt_sldwjlzb: '所有检测结果中，各种四轮定位结论的轮胎条数及占比',
    txt_sldwfbqk: '四轮定位结论条数分布情况',
    txt_btjgsldwzb: '不同条数四轮定位结论的报告数量、以及在总检测数中的占比',
    txt_jccsqs: 'Andamento della quantità ispezionata',
    txt_msqkslqs: "Evoluzione dell'usura dei pneumatici",
    txt_jgfbqushi: '磨损轮胎需更换轮胎的结果分布趋势',
    txt_msltjgfbqs: '磨损轮胎需注意轮胎的结果分布趋势',
    txt_ltxsldwslqs: '轮胎需四轮定位情况数量趋势',
    txt_jccs: 'Totale ispezioni',
    txt_shuliang: "Q'ty",
    txt_zhanbi: '%',
    txt_chankangd: 'Più',
    txt_chakanmdxxbb: 'Dettagli',


    //国家
    txt_zhongguo: 'Cina',
    txt_mlxy: 'Malesia',
    txt_yindu: 'India',
    txt_taiguo: 'Thailandia',
    txt_oluosi: 'Russia',



    txt_taici: 'Veicoli',
    txt_jianyi: 'Suggerimenti:',
    txt_jianyineirong: 'Usura parziale dei pneumatici. Per favore rileva ulteriormente',
    txt_jianyineirongzc: 'Normale',
    txt_bgtixing: 'Promemoria:',
    txt_bgtuxubfnr: "Può aumentare la distanza di frenata del {0}% (valore stimato) in base all'usura attuale dei pneumatici",
    txt_waishang: 'Difetto del pneumatico',
    txt_laohua: 'Invecchiamento',
    txt_gubao: 'Rigonfiamento',
    txt_xichemeirong: 'Autolavaggio e bellezza',
    txt_weixiubaoyang: 'Manutenzione',
    txt_guenghuanluntai: 'Sostituzione pneumatico',
    txt_scsltjcy: 'Rivelatore per pneumatici portatile',
    txt_shijiantishi: "L'orario di inizio deve essere inferiore all'orario di fine",

    txt_qxzclry: 'Seleziona',

    txt_lf_outworn: "L'esterno del pneumatico anteriore sinistro è più usurato rispetto all'interno",
    txt_lf_innerworn: "L'interno del pneumatico anteriore sinistro è più usurato rispetto all'esterno",
    txt_lf_bothsideworn: 'Entrambi i lati del pneumatico anteriore sinistro sono più consumati rispetto al centro',
    txt_lf_centreworn: 'Il centro del pneumatico anteriore sinistro è più usurato rispetto a entrambi i lati',
    txt_lb_outworn: "L'esterno del pneumatico posteriore sinistro è più usurato rispetto all'interno ",
    txt_lb_innerworn: "L'interno del pneumatico posteriore sinistro è più usurato rispetto all'esterno",
    txt_lb_bothsideworn: 'Entrambi i lati del pneumatico posteriore sinistro sono più consumati rispetto al centro',
    txt_lb_centreworn: 'Il centro del pneumatico posteriore sinistro è più usurato rispetto a entrambi i lati',
    txt_rb_outworn: "L'esterno del pneumatico posteriore destro è più usurato rispetto all'interno",
    txt_rb_innerworn: "L'interno del pneumatico posteriore destro è più usurato rispetto all'esterno",
    txt_rb_bothsideworn: 'Entrambi i lati del pneumatico posteriore destro sono più consumati rispetto al centro',
    txt_rb_centreworn: 'Il centro del pneumatico posteriore destro è più usurato rispetto a entrambi i lati",',
    txt_rf_outworn: "L'esterno del pneumatico anteriore destro è più usurato rispetto all'interno",
    txt_rf_innerworn: "L'interno del pneumatico anteriore destro è più usurato rispetto all'esterno",
    txt_rf_bothsideworn: 'Entrambi i lati del pneumatico anteriore destro sono più consumati rispetto al centro"',
    txt_rf_centreworn: 'Il centro del pneumatico anteriore destro è più usurato rispetto a entrambi i lati',
    txt_tire_need_replace: "Esiste l'usura parziale, i pneumatici devono essere sostituiti immediatamente",
    txt_tire_boundary: "Esiste l'usura parziale, è già nello stato limite",
    'txt_tire_boundary;': "Esiste l'usura parziale, è già nello stato limite",
    txt_alignment_chassis: 'Si consiglia di eseguire ulteriori allineamento a quattro ruote o rilevamento del telaio.',
    txt_wear_uniform: "L'usura dei pneumatici singoli è più uniforme",
    'txt_wear_uniform;': "L'usura dei pneumatici singoli è più uniforme",
    txt_do_further_check: 'Per favore rileva ulteriormente',
    txt_uneven_check: "Esiste un'usura eccessiva e si consiglia un ulteriore rilevamento",
    'txt_uneven_check;': "Esiste un'usura eccessiva e si consiglia un ulteriore rilevamento",
    txt_tire_rotation: 'Trasposizione dei pneumatici raccomandata',
    txt_wear_normal: 'Usura normale dei pneumatici',
    'txt_wear_normal;': 'Usura normale dei pneumatici',
    txt_tire: 'Pneumatico ',
    txt_xiazai: 'Scarica',
    txt_xiazaishibai: 'Scarico dati non riuscito',
    txt_fanhui: 'Retro',
    txt_yszc: 'Politica in materia di tutela della vita privata ',
    txt_djtyjbsydty: 'Scarica Android ',
    txt_djyszc: '《Politica in materia di tutela della vita privata》',
    txt_tongyi: "D'accordo",
    txt_btongyi: "Non d'accordo",
    txt_yszcnr: "[si prega di osservare che] in caso di disaccordo con l'accordo o con una delle sue disposizioni, si prega di sospendere la registrazione.  Non potete usufruire dei nostri servizi quando avete smesso di registrarvi.  Se compilate le informazioni secondo la procedura di registrazione, leggete e cliccate sul vostro consenso al protocollo di cui sopra e completate la procedura di registrazione, dicendovi di aver letto a fondo e di aver compreso e accettato l'intero contenuto dell'accordo  ",
    txt_qsrszcs: '请输入所在城市',
    txt_qsrszsf: '请输入所在省份',
    txt_qwsxx: '请完善信息',
    txt_shujufx: '数据分享',
    txt_fenxiang: '分享',
    txt_djxybbs: '点击下一步表示你已阅读并同意',
    txt_yhxy: '《用户协议》',
    txt_xxfxsz: 'Impostazioni di sistema',
    txt_jsfzh: '接收方账号',
    txt_xzfxxx: '选择分享信息',
    txt_jianceliang: '检测量',
    txt_fenxiangjieshu: '分享结束时间',
    txt_jieshou: '接收',
    txt_jujue: '拒绝',
    txt_jieshoufenxiang: '接受分享',
    txt_jieshoushanghu: '接收商户:',
    txt_zhongzhi: '终止',
    txt_fenxiangzhong: '分享中',
    txt_fenxiangshanghu: '分享商户',
    txt_jieshouzhong: '接收中',
    txt_sousuo: '搜索',
    txt_jiance: 'Rilevamento',

    txt_fenxiangtishi: '对方没有分享此数据给您，无权查看',


    //报告新增 
    'txt_tire_age_8': 'Esistono pneumatici usati da più di cinque anni e si propone un controllo completo',
    'txt_tire_age_6': 'Esistono pneumatici usati da più di tre anni e si propone un controllo completo',
    'txt_tire_age_5': 'Pneumatici utilizzati da oltre cinque anni,  si propone un controllo completo e la sostituzione',
    'txt_tire_age_3': 'Esistono pneumatici usati da più di tre anni e si propone un controllo completo',
    'txt_tire_age_ok': 'DOT OK',
    'txt_tire_age_ok;': 'DOT OK',
    'txt_tire_trauma_check': 'Il pneumatico è danneggiato, si raccomanda un`ulteriore ispezione',
    'txt_install_abnormal_check': 'Si raccomanda di effettuare ulteriori controlli',
    'txt_tire_appearance_ok': 'Aspetto del pneumatico OK',
    'trauma_lacerate': 'Lacerata',
    'trauma_dropblock': 'Blocco di goccia',
    'trauma_puncture': 'Foratura',
    'trauma_scratch': 'Sfregamento',
    'txt_tire_age': 'Anzianità di pneumatici',
    'txt_tire_appearance': 'Aspetto del pneumatico',
    txt_plcl: 'Batch',
    txt_qbxz: 'All',
    txt_scjcjg: 'Last',
    txt_ltxhlcgs: 'Tire range estimation',
    txt_ltazhuang: 'Installation:',
    txt_wear_overall: 'Usura generale',
    txt_pattern_wear: 'Usura parziale',

    txt_ltlcgstm: 'In base allo stato di usura dei pneumatici, il chilometraggio dei pneumatici è {0} km (valore stimato)',
    txt_yichang: 'Anormale',
    txt_qjybjcltazqk: "Verifica problemi di installazione del pneumatico",
    txt_dottx: 'Stima della durata pneumatici',
    txt_dottxjy: 'Gli pneumatici sono stati usati per più di tre anni, per favore controllali regolarmente',
    txt_danweinian: '(Unità:Anno)',
    txt_danweikm: '(Unità:km)',
    txt_shurujb: "Inserisci 'Dissocia'per disarmare il dispositivo",
    txt_shuruzqwa: 'Inserisci il testo come richiesto',
    txt_myhqdsj: 'No DOT',
    txt_dotjstx: 'Il tempo residuo di utilizzo del pneumatico è circa {0} giorni ',
    txt_dotjstx2: 'Pneumatici utilizzati da oltre cinque anni,  si propone un controllo completo e la sostituzione',
    txt_dotsjztx: '(DOT: data fabbricazione)',
    txt_gelie: 'Lacerato',
    txt_diaokuai: 'Blocco di goccia',
    txt_chaungci: 'foratura',
    txt_cashang: 'Sfregamento',
    //txt_yichang: 'Pneumatico anormale',
    //txt_tire_need_replace: "Il pneumatico è gravemente usurato, si raccomanda di sostituire il pneumatico",
   
    txt_jishimz: 'tecnico',
    txt_ltlcgsnew: 'Promemoria: secondo le attuali condizioni di usura dei pneumatici, il chilometraggio residuo degli pneumatici è circa',
    txt_ltlcgsnewin: 'Chilometraggio residuo {0}',
    txt_pinnate_check: "c'è l'usura della piuma sul pneumatico, si prega di controllare ulteriormente",
    txt_pinnate_wear: 'usura delle piume',
    txt_msjxtx: 'Il pneumatico ha raggiunto il limite, si prega di sostituirlo immediatamente',
    txt_ltfz: 'Pneumatici installati al contrario',
    txt_install_check: "Controllo dell'installazione",
    txt_install_ok: 'Normale',
    LF: '[Anteriore sinistra]',
    LB: '[Posteriore sinistra]',
    RF: '[Anteriore destra]',    
    RB: '[Posteriore destra]',
    FF: '[Asse anteriore]',
    BB: '[Asse posteriore ]',
    txt_appearance_check: "Il pneumatico è danneggiato, si raccomanda un`ulteriore ispezione",
    txt_uneven_center: 'La parte centrale del pneumatico è usurato parzialmente, verifica la pressione.',
    txt_uneven_out: "Entrambi i lati del pneumatico sono usurati parzialmente. Si raccomanda di controllare l'allineamento delle quattro ruote e la pressione dei pneumatici",
    //txt_pinnate_check: "C'è l'usura della piuma sul pneumatico. Si raccomanda di controllare ulteriormente le parti del telai",
    txt_uneven_inside: "Il lato interno del pneumatico è parzialmente usurato. Si raccomanda di controllare l'allineamento delle quattro ruote e la pressione dei pneumatici",
    txt_uneven_bothside: "Entrambi i lati del pneumatico sono usurati parzialmente. Si raccomanda di controllare l'allineamento delle quattro ruote e la pressione dei pneumatici",

    txt_msyzljgh: 'Il pneumatico è gravemente usurato, si raccomanda di sostituire il pneumatico.',
    txt_serious_trauma_check: "Il pneumatico è gravemente danneggiato. Si raccomanda di sostituire il pneumatico",
    txt_appearance_lookup: "Per favore controlla l'aspetto dei pneumatici",
    txt_wear_lookup: "Per favore, controlla l'usura dei pneumatici",
    txt_dotscsj: 'Tempo di produzione: {0}({1} anno {2} settimana)',
    txt_whqdscsj: 'No DOT',
    purp_tireservice: 'Servizio di pneumatici',
    purp_vehicle_inspection: 'Ispezione Veicolo',
    txt_chassis_check: 'Controllo telaio',
    txt_chassis_ok: 'Telaio OK',
    txt_chassis_oil: "Gli ammortizzatori perdono olio, effettuare ulteriori verifiche",
    txt_chassis_aging: "Invecchiamento spallatura pneumatico, si consiglio di sostituirlo immediatamente",



    // new add  wu
    txt_lights:'Luci',
    txt_under_hood:'Cofano motore',
    txt_trans_fluid:'Olio motore',
    txt_windshield_washer_fluid:'Liquido lavavetri',
    txt_ac_system:'CLIMATIZZATORE',
    txt_battery:'Batteria',
    txt_under_vehicle:'Telaio',
    txt_AC_system:'Aria condizionata',
 

    txt_hood: 'COFANO MOTORE',
    txt_wash_liquid: 'LIQUIDO LAVAVETRI',
    txt_level_control: 'CONTROLLO LIVELLO',
    txt_haoxiaoxi: 'OK:OK',
    txt_vedi_Note: 'VEDI NOTE:Programmazione lavoro',
    txt_replace1: 'Sostituzione:Concordare lavoro immediato',
    txt_radiator_fluid: 'FLUIDO RADIATORE',
    txt_engine_oil: 'OLIO MOTORE',
    txt_brake_fluid: 'LIQUIDO FRENI',
    txt_quality_control: 'CONTROLLO QUALITA',
    txt_multimeter: 'TEST MULTIMETRO',
    txt_subtotal: 'SOTTOSCOCCA',
    txt_shock_absorber: 'AMMORTIZZATORI',
    txt_check_loss: 'VERIFICA PERDITE VISIBILI',
    txt_brake_disc: 'DISCHI FRENO',
    txt_wear_condition: 'STATO DI USURA',
    txt_brake_pads: 'PASTIGLIE FRENO',
    txt_change_control: 'ALTERI CONTROLLI',
    txt_air_control: 'CLIMATIZZATORE',
    txt_last_reload: 'ULTIMA RICARICA',
    txt_lighting: 'FANALERIA',
    txt_verification1: 'TERGICRISTALLI',
    txt_dynamometer: 'SERRAGGIO CON DINAMOMETRICA EFFETTUATO DA',
    txt_batteria: 'BATTERIA',
    txt_verification: 'VERIFICA FUNZIONAMENTO',
    txt_levellow: 'OK',
    txt_levelmiddle: 'VEDI NOTE',
    txt_levelhigh: 'Sostituzione',
    txt_tyrenumber: 'Profondità di scansione:',
    txt_cormach_title: 'Usura&Usura parziale',
    txt_wearlow: 'Usura uniforme del motivo',
    txt_wearmiddle: 'Leggera usura parziale',
    txt_wearhigh: 'Grave usura parziale',
    txt_zhiliangkongzhi: 'Controllo qualita',
    txt_buchongzhengduan: 'Supplemento Diagnostico',
    txt_season_summer: 'PNEUMATICO ESTIVO',
    txt_season_winter: 'PNEUMATICO INVERNALE',

    //
    txt_trauma_eattyre: 'mangiano pneumatici',
    txt_uneven_eattyre: 'Il pneumatico è gravemente usurato, controlla le sospensioni',
    txt_appearance_eattyre: 'Il pneumatico è gravemente usurato, controlla le sospensioni',
    txt_chassis_eattyre: 'Il pneumatico è gravemente usurato, controlla le sospensioni',
    txt_uneven_high_eattyre: "Il pneumatico è gravemente usurato, controlla le sospensioni",
    txt_appearance_high_eattyre: "Il pneumatico è gravemente usurato, controlla le sospensioni",
    txt_chassis_high_eattyre: 'Il pneumatico è gravemente usurato, controlla le sospensioni',
    txt_chassis_uneven: 'Il pneumatico è gravemente usurato, controlla le sospensioni',
    txt_pianmoyichang: 'usura parziale anormale degli pneumatici',
    txt_qiao: 'Ponte',
    txt_left: 'Sinistra',
    txt_right: 'Destro',
    txt_lun: 'Rotondo',
    txt_huawen: 'Schema Decorativo',
    txt_taihao: 'Numero Di Pneumatici',
    txt_taiya: 'Pressione Del Pneumatico',
    txt_chexlw: 'Posizione Della Ruota',
    txt_jiancerenyuan: 'Personale Di Prova',
    txt_beitai: 'Ruota Di Scorta',
    txt_tuoche: 'Rimorchio',
    txt_guache: 'Gru',


    txt_khxm: 'Nome cliente',
    txt_khyx: 'Mail cliente',

    txt_tireplace:'Posizione pneumatico',
    txt_tire_season:'Pneumatici di stagione',
    txt_tire_other:'Altri pneumatici',
    txt_bolt:'Bolo',
    txt_goods_name:'Nome merci',
    txt_yes:'Sì',
    txt_no:'No',
}


// WEBPACK FOOTER //
// ./src/i18n/italian.js